import React from 'react';
import { FDBodyText, FDSlider, FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';


function ExpensesReducibilitySlider() {
  const {
    resource,
    handleChange,
  } = useMetaLayoutContext();

  function onChange(value) {
    handleChange(
      'expensesReducibilityPercentage',
      value,
    );
  }

  const reducePercentage = `${resource.attr('expensesReducibilityPercentage')}%`;
  const reduceAmount = Math.round(resource.attr('expensesReducibilityPercentage') * (resource.attr('flexibleExpenseTotal') / 100));
  const reducedAmount = `You've chosen to reduce your flexible expenses room by ${reducePercentage} (or $${reduceAmount}) per month`;

  return (
    <FDStack direction={'column'} justifyContent={'center'} spacing={1}>
      <FDSlider
        min={resource.metaField('expensesReducibilityPercentage').attr('min')}
        max={resource.metaField('expensesReducibilityPercentage').attr('max')}
        value={Number(resource.attr('expensesReducibilityPercentage'))}
        onChange={onChange}
        label={'Slide'}
      />
      <FDBodyText value={reducedAmount} size={'lg'} />
    </FDStack>
  );
}

ExpensesReducibilitySlider.propTypes = {};

export default ExpensesReducibilitySlider;
